import Hotspots from "./hotspots/Hotspots";

const VariationImage = ({ img, large = false, hotspots, onHotspotDrag }) => {
  return (
    <div
      style={{
        width: large ? "var(--width-80)" : "var(--width-20)",
        height: large ? "var(--width-80)" : "var(--width-20)",
        borderRadius: "var(--rounded)",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {hotspots != null && img != null ? (
        <Hotspots hotspots={hotspots} onChange={onHotspotDrag} large={large} />
      ) : null}
      <img
        style={{ width: "100%", height: "100%" }}
        src={img || "/image_placeholder.jpg"}
        alt="Variation"
      />
    </div>
  );
};

export default VariationImage;
